import { Stethoscope } from "lucide-react";
import { DOCTORS } from "@/lib/clinic";

export default function Equipo() {
  return (
    <section
      id="equipo"
      data-testid="equipo-section"
      className="py-20 md:py-28 bg-turquoise-50"
    >
      <div className="section-container grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <span className="text-[11px] tracking-[0.24em] uppercase text-turquoise-700 font-semibold">
            Equipo médico
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-navy-900 leading-tight">
            Profesionales <span className="italic text-turquoise-700 font-light">dedicados</span> a tu visión.
          </h2>
          <p className="mt-5 text-base text-navy-800/75 leading-relaxed max-w-md">
            Un equipo médico con amplia trayectoria, formación continua y un compromiso genuino con la atención cercana.
          </p>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
          {DOCTORS.map((doc) => (
            <div
              key={doc.name}
              data-testid={`doctor-card-${doc.name.replace(/\s+/g, "-").toLowerCase()}`}
              className="group relative rounded-3xl bg-white p-7 border border-navy-900/5 shadow-[0_8px_30px_rgba(11,27,61,0.04)] transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_24px_50px_-20px_rgba(11,27,61,0.18)]"
            >
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-2xl bg-turquoise-100 flex items-center justify-center text-turquoise-700">
                  <Stethoscope className="w-7 h-7" strokeWidth={1.7} />
                </div>
                <div>
                  <h3 className="font-display text-xl font-semibold text-navy-900 leading-tight">
                    {doc.name}
                  </h3>
                  <p className="text-sm text-turquoise-700 font-medium">{doc.role}</p>
                </div>
              </div>
              <p className="mt-5 text-sm text-navy-800/70 leading-relaxed">
                Consulta, diagnóstico y tratamiento integral en cirugía refractiva, catarata y salud visual preventiva.
              </p>
            </div>
          ))}

          <div className="sm:col-span-2 rounded-3xl bg-navy-900 text-cream p-8 relative overflow-hidden">
            <div className="pointer-events-none absolute -right-20 -bottom-20 w-60 h-60 rounded-full bg-turquoise-500/20 blur-3xl" />
            <p className="font-display text-xl sm:text-2xl font-medium max-w-lg leading-snug relative">
              Un espacio pensado para que tu consulta sea <span className="text-turquoise-300 italic font-light">tranquila y cuidada</span>, de principio a fin.
            </p>
            <p className="mt-4 text-cream/70 text-sm max-w-md relative">
              Atención personalizada, turnos puntuales y un entorno cálido que acompaña cada etapa del cuidado visual.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
